module.exports = __webpack_public_path__ + "static/media/gallery.fcafc048.png";